import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function OneAnalysisLeft({ to = "/hitung", label = "Lanjutkan Analisis" }) {
  const navigate = useNavigate();
  return (
    <div className="bg-teal/5 border border-teal/20 rounded-xl p-4 flex items-center justify-between gap-3 flex-wrap" data-testid="one-analysis-left">
      <p className="text-sm text-navy font-medium">Anda masih punya 1 analisis gratis.</p>
      <Button data-testid="one-analysis-left-cta" size="sm" onClick={() => navigate(to)} className="rounded-full bg-teal hover:bg-teal-hover">{label}</Button>
    </div>
  );
}
